import { render, staticRenderFns } from "./accidentReportCreate.vue?vue&type=template&id=db097352&scoped=true&"
import script from "./accidentReportCreate.vue?vue&type=script&lang=js&"
export * from "./accidentReportCreate.vue?vue&type=script&lang=js&"
import style0 from "./accidentReportCreate.vue?vue&type=style&index=0&id=db097352&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db097352",
  null
  
)

export default component.exports